import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { LANGUAGE_LABELS, VERDICT_LABELS } from '@flarecode/shared';
import { api } from '../lib/api';
import { useCurrentUser } from '../hooks/useCurrentUser';

export function SubmissionListPage() {
  const { user, isLoading: userLoading } = useCurrentUser();

  const { data, isLoading, error } = useQuery({
    queryKey: ['submissions'],
    queryFn: () => api.listSubmissions(),
    enabled: !!user,
  });

  if (userLoading) return <p>Loading…</p>;
  if (!user) {
    return (
      <section>
        <h2>My submissions</h2>
        <p className="empty">
          <Link to="/login">Sign in</Link> to see your submissions.
        </p>
      </section>
    );
  }
  if (isLoading) return <p>Loading submissions…</p>;
  if (error) return <p className="error">Failed to load submissions.</p>;

  const submissions = data?.submissions ?? [];

  return (
    <section>
      <h2>My submissions</h2>
      {submissions.length === 0 ? (
        <p className="empty">
          No submissions yet. <Link to="/problems">Pick a problem</Link> and try one.
        </p>
      ) : (
        <table className="problem-list">
          <thead>
            <tr>
              <th>When</th>
              <th>Problem</th>
              <th>Language</th>
              <th>Verdict</th>
              <th>Runtime</th>
              <th>Memory</th>
            </tr>
          </thead>
          <tbody>
            {submissions.map((s) => (
              <tr key={s.id}>
                <td>
                  <Link to={`/submissions/${s.id}`}>{new Date(s.createdAt).toLocaleString()}</Link>
                </td>
                <td>
                  <Link to={`/problems/${s.problemSlug}`}>{s.problemTitle}</Link>
                </td>
                <td>{LANGUAGE_LABELS[s.language]}</td>
                <td>
                  <span className={`verdict-badge verdict--${s.verdict}`}>
                    {VERDICT_LABELS[s.verdict]}
                  </span>
                </td>
                <td>{s.runtimeMs != null ? `${s.runtimeMs} ms` : '—'}</td>
                <td>{s.memoryKb != null ? `${Math.round(s.memoryKb / 1024)} MB` : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
